import { render } from "./Partner.vue?vue&type=template&id=6c7ed840&scoped=true"
import script from "./Partner.vue?vue&type=script&lang=js"
export * from "./Partner.vue?vue&type=script&lang=js"

import "./Partner.vue?vue&type=style&index=0&id=6c7ed840&scoped=true&lang=css"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7ed840"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';import Scroll from 'quasar/src/directives/Scroll.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg});qInstall(script, 'directives', {Scroll});
